export { useMorphemeInfoPanelCompositionCompoundsSection } from "#morpheme-info-panel-composition-compounds-view";
